// IndexNow — pings Bing (and Google via Bing) when a new post is published
// This helps new content get indexed within minutes, not days
// Key must match the file at /public/{key}.txt

const INDEXNOW_KEY = 'margins-indexnow-key'
const SITE_URL = 'https://themarginsjournal.com'

export async function pingIndexNow(postId) {
  const url = `${SITE_URL}/post/${postId}`
  try {
    await fetch(`https://api.indexnow.org/IndexNow`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      body: JSON.stringify({
        host: 'themarginsjournal.com',
        key: INDEXNOW_KEY,
        keyLocation: `${SITE_URL}/${INDEXNOW_KEY}.txt`,
        urlList: [url],
      }),
    })
  } catch {
    // Non-critical — don't surface errors to the user
  }
}
